const homeIt = {
    "hi": "Ciao, mi chiamo Alessio! ",
    "hi-subheadline": "Sono un ingegnere informatico e un insegnante nelle scuole superiori.",
    "who-am-i": "Chi sono",
    "about": {
        "1": "Ho studiato Ingegneria informatica presso il Politecnico di Torino. Al momento insegno Informatica " +
            "nelle scuole superiori e sviluppo applicazioni web e mobile.",
        "2": "Su questo sito trovi alcuni dei miei lavori e progetti personali che ho realizzato nel corso del tempo."
    },
    "interests": "Interessi e competenze",
    "scroll-to-know-more": "Scorri i riquadri per saperne di più!",
    "show-more": "Scopri di più",
    "visit-website": "Visita il sito",
    "web-applications": {
        "title": "Applicazioni web",
        "front-end": "Front end: React",
        "back-end": "Back end: Express o Spring",
        "traditional": "Programmazione web tradizionale"
    },
    "mobile-applications": {
        "title": "Applicazioni mobile",
        "ios": "iOS (Swift, SwiftUI)",
        "android": "Android (Kotlin, view-based o Jetpack Compose)"
    },
    "system-programming": {
        "title": "Programmazione di sistema e algoritmi",
        "languages": "C, C++, Rust, Java, Bash, assembler ARM e MIPS"
    },
    "other-computer-sciences": {
        "title": "Altri ambiti informatici",
        "db": "Database relazionali e non relazionali",
        "networks": "Configurazione e analisi di reti",
        "cybersecurity": "Sicurezza informatica"
    },
    "works": {
        "title": "Lavori e progetti",
        "description": {
            "1": "Attualmente insegno Informatica nelle scuole superiori, ma nel tempo ho realizzato e continuo a " +
                "realizzare progetti personali e lavori. Ne ho raccolti alcuni qui sotto.",
            "2": "Su <1>GitHub</1> trovi alcuni di questi progetti e anche il <3>repository</3> di questo stesso sito.",
        }
    },
    "across-the-spider-verse": "In giro per il web",
    "projects": {
        "title": "I miei progetti",
        "subtitle": "Alcuni miei lavori e progetti personali",
        "gestionale": {
            "subtitle": "Un'applicazione web per la gestione del personale e delle ore lavorate",
            "description": "Scritto in TypeScript usando Express come framework back-end e React per il front end, " +
                "Gestionale permette di registrare le ore lavorate, gestire gli ordini aziendali e i ticket di assistenza. " +
                "Lato amministrativo permette anche di gestire le commesse e calcolarne il costo in base alle ore lavorate, " +
                "permette di visualizzare le ore lavorate aggregate per commessa, mese e dipendente, di pianificare le " +
                "attività e gestire il piano ferie."
        },
        "fantanenbun": {
            "subtitle": "Una web app per il Fanta del torneo di pallavolo del mio oratorio",
            "description": "Tutti gli anni, a giugno, nel mio oratorio si tiene un torneo di pallavolo amatoriale, " +
                "il Torneo dei Nen Bun. Da qualche anno ormai il torneo è arricchito dal FantaNenBun, una competizione " +
                "a cui è possibile partecipare tramite questa web app. Ogni utente, iscrivendosi, è chiamato a " +
                "scegliere tre squadre tra quelle partecipanti al torneo. Queste squadre guadagnano punti nel corso " +
                "del torneo in base a fantasiosi bonus e malus: l'utente le cui squadre totalizzano più punti vince!"
        },
        "keepsmiling": {
            "subtitle": "Un portale per la gestione delle iscrizioni ad un'associazione sportiva",
            "description": "Un'applicazione web scritta in PHP che espone dei form di iscrizione ai vari programmi " +
                "dell'associazione sportiva, con generazione di moduli di iscrizione precompilati inviati via email " +
                "ed emissione delle ricevute di pagamento. Successivamente la sezione di amministrazione consente di " +
                "gestire i partecipanti ai vari corsi e di visualizzare la documentazione inviata."
        }
    },
    "festivities-greetings": {
        "christmas": "Buon Natale!",
        "new-year": "Buon anno!",
        "easter": "Buona Pasqua!",
        "birthday": "Buon compleanno Alessio!"
    }
}

const homeEn = {
    "hi": "Hi! I'm Alessio! ",
    "hi-subheadline": "I'm a computer engineer and a high school teacher.",
    "who-am-i": "Who am I",
    "about": {
        "1": "I studied Computer engineering at Politecnico di Torino. I currently teach Computer Science in high " +
            "school and develop web and mobile applications.",
        "2": "On this website you can find some of my works and personal projects I developed throughout time."
    },
    "scroll-to-know-more": "Scroll the boxes to get to know more!",
    "show-more": "Show more",
    "visit-website": "Visit the website",
    "interests": "Interests and expertise",
    "web-applications": {
        "title": "Web applications",
        "front-end": "Front end: React",
        "back-end": "Back end: Express or Spring",
        "traditional": "Traditional web programming"
    },
    "mobile-applications": {
        "title": "Mobile applications",
        "ios": "iOS (Swift, SwiftUI)",
        "android": "Android (Kotlin, view-based or Jetpack Compose)"
    },
    "system-programming": {
        "title": "System programming and algorithms",
        "languages": "C, C++, Rust, Java, Bash, ARM and MIPS assembler"
    },
    "other-computer-sciences": {
        "title": "Other computer science fields",
        "db": "Relational and non-relational databases",
        "networks": "Networks configuration and analysis",
        "cybersecurity": "Cybersecurity"
    },
    "works": {
        "title": "Works and projects",
        "description": {
            "1": "I currently teach Computer Science in high school, but in the meantime I have developed and keep " +
                "developing some works and personal projects. You can find some below.",
            "2": "On <1>GitHub</1> you can find some of these projects and even the <3>repository</3> of this very website."
        },
    },
    "across-the-spider-verse": "Across the Spider-Verse (the web)",
    "projects": {
        "title": "My projects",
        "subtitle": "Some of my works and personal projects",
        "gestionale": {
            "subtitle": "A web application to manage personnel and register worked hours",
            "description": "Written in TypeScript using Express as a back-end framework and React for the front end, " +
                "Gestionale allows you to register worked hours, manage the company orders and assistance tickets. " +
                "On the administrative side it allows you to manage jobs and to calculate their cost based on the worked " +
                "hours, to see the worked hours aggregated by job, month and employee, to plan the activities and to " +
                "manage the holiday plan."
        },
        "fantanenbun": {
            "subtitleIT": "Una web app per il Fanta del torneo di pallavolo del mio oratorio",
            "subtitle": "A web app for a fantasy football-like competition held during the volleyball tournament " +
                "organized by my parish",
            "description": 'Every year in June, my parish holds an amateur volleyball tournament, the "Nen Bun" ' +
                'Tournament. For a few years now, the tournament has been enriched with FantaNenBun, ' +
                'a competition you can participate in via this web app. Each user, upon registration, is asked to ' +
                'choose three teams from those participating in the tournament. These teams earn points throughout ' +
                'the tournament based on imaginative bonuses and penalties: the user whose teams score ' +
                'the most points wins!'
        },
        "keepsmiling": {
            "subtitle": "A website for managing memberships for a sports association",
            "description": "A web application written in PHP that displays registration forms for the sports " +
                "association's various programs, generating pre-filled registration forms sent via email and " +
                "issuing payment receipts. The administration section then allows you to manage the participants to the " +
                "various courses and review the submitted documentation."
        }
    },
    "festivities-greetings": {
        "christmas": "Merry Christmas!",
        "new-year": "Happy New Year!",
        "easter": "Happy Easter!",
        "birthday": "Happy birthday Alessio!"
    }
}

export {homeIt, homeEn};